import { TInquiriesDetailsData } from "@/interfaces";

const VehicleCardInquiryDetails = ({
  data,
}: {
  data: TInquiriesDetailsData;
}) => {
  return <div>InquiryDetails</div>;
};

export default VehicleCardInquiryDetails;
